export class TimeEntryCategory {
  id: string;
  externalId: string;
  name: string;
  color: string;
  enabled: boolean;

  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      this.externalId = payload.externalId;
      this.name = payload.name;
      this.color = payload.color;
      this.enabled = payload.enabled;
    }
  }

  static createTimeCategoryEntries(result: Array<any>): TimeEntryCategory[] {
    const timeCategoryEntries = new Array<TimeEntryCategory>();
    if (result) {
      result.map((timeCategoryEntry) => {
        timeCategoryEntries.push(new TimeEntryCategory(timeCategoryEntry));
      });
    }
    return timeCategoryEntries;
  }
}

export class TimeEntryCategoryInput {
  id: string;
  name: string;
  externalId: string;
  color: string;
  enabled: boolean;

  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      this.name = payload.name;
      this.externalId = payload.externalId;
      this.color = payload.color;
      this.enabled = payload.enabled;
    }
  }
}
